export default __webpack_public_path__ + "static/media/olumide.496ce4eb.jpg";